import { QualityTypeEnum } from "@gtpl/shared-models/common-models";

export class QaqcWorkOrderReq {
    plantId?: number;
    isActive?: boolean;
    lotNumber?: string;
    workOrderNo?: string;
    quality?: QualityTypeEnum;
    fromDate?: Date;
    toDate?: Date;
    variant?: string;

}

export class QaqcLotReq {
    plantId?: number;
    isActive?: boolean;
    lotNumber?: string;
    workOrderNo?: string;
    quality?: QualityTypeEnum;
    fromDate?: Date;
    toDate?: Date;
    variant?: string;
}

export class CreateQaqcFibreAnalysisReq {
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    product: string;
    quality: string;
    meanLength?: number;
    shortestFiber?: number;
    longestFiber?: number;
    shortFiberPercent?: number;
    slub?: number;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
    testDate?: Date;
    productionInventoryId?: number;
}

export class CreateQaqcFibreLabAnalysisReq {
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    product: string;
    quality: string;
    oilTest?: number;
    oilTestRemarks?: string;
    sericinTest?: number;
    sericinTestRemarks?: string;
    acidityTest?: number;
    acidityTestRemarks?: string;
    ppContent?: number;
    ppContentRemarks?: string;
    moistureContent?: number;
    moistureContentRemarks?: string;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
    testDate?: Date;
    productionInventoryId?: number;
}

export class UpdateQaqcFibreAnalysisReq {
    id: number;
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    product: string;
    quality: string;
    meanLength?: number;
    shortestFiber?: number;
    longestFiber?: number;
    shortFiberPercent?: number;
    slub?: number;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
}

export class UpdateQaqcFibreLabAnalysisReq {
    id: number;
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    product: string;
    quality: string;
    oilTest?: number;
    oilTestRemarks?: string;
    sericinTest?: number;
    sericinTestRemarks?: string;
    acidityTest?: number;
    acidityTestRemarks?: string;
    ppContent?: number;
    ppContentRemarks?: string;
    moistureContent?: number;
    moistureContentRemarks?: string;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
}

export class QaqcApprovalReq {
    id: number;
    testType: string;
    analysisType: string;
}


export class QaqcApprovalStatusReq {
    workOrderNo?: string;
    lotNumber?: string;
}

export class CreateProductCountItemReq {
    processType: string;
    weightInGms: number;
    count: number;
}

export class CreateQaqcProductCountsReq {
    testDate: Date;
    lotNumber: string;
    operation: string;
    product: string;
    quality: QualityTypeEnum;
    quantity: number;
    productType?: string;
    items?: CreateProductCountItemReq[];
    isQAQCApproved?: boolean;
    is_qaqc_one_done?: boolean;
    is_qaqc_two_done?: boolean;
    is_qaqc_three_done?: boolean;
}

export class UpdateQaqcProductCountsReq {
    id: number;
    testDate: Date;
    lotNumber: string;
    operation: string;
    product: string;
    quality: QualityTypeEnum;
    quantity: number;
    processType: string;
    weightInGms: number;
    count: number;
    productType?: string;
    isQAQCApproved?: boolean;
    is_qaqc_one_done?: boolean;
    is_qaqc_two_done?: boolean;
    is_qaqc_three_done?: boolean;
}

